<template>
  <div class="md-wrapper">
      <div class="wb-padding-s" style="background: #ffffff">
        <wb-card variant="light-grey" class="wb-padding-s">
          <h4 style="text-align:left">Steps to generate app password</h4>
          <br/>
        <wb-list style="text-align:left" variant="numbered">
          <wb-list-item v-for="pwd in pwdInst.instArr" :key="pwd.inst">{{ pwd.inst }}</wb-list-item>
        </wb-list>
        </wb-card>
          <div v-if="pwdInst.img">
            <img v-bind:src="pwdInst.img" alt="" class="imageCls">
          </div>
        <div v-if="pwdInst.instArray">
          <wb-card variant="light-grey" class="wb-padding-s">
            <h4 style="text-align:left">Steps to access calendar</h4>
            <br/>
            <wb-list style="text-align:left" variant="numbered">
              <wb-list-item v-for="pwd in pwdInst.instArray" :key="pwd.inst">{{pwd.inst}}</wb-list-item>
            </wb-list>
          </wb-card>
        </div>
        </div>
     </div>
</template>

<script>
import { useI18n } from "vue-i18n";
import  yahoo  from "../providers/yahoo.json";
import  zoho  from "../providers/zoho.json";
import  web  from "../providers/web.de.json";
import  gmx  from "../providers/gmx.json";
import  icloud from "../providers/icloud.json";
import tonline from "../providers/tonline.de.json"

export default {
  name: 'MoreDetails',
  setup() {
    const { t, locale } = useI18n();
    return { t, locale };
  },
  data() {
    return {
      emailDomain: "",
      pwdInst: [],
    }
  },
  mounted() {
    let emailDomain = localStorage.getItem("emailDomain");
    this.emailDomain = emailDomain;
    if(emailDomain == "YAHOO") {
      this.pwdInst = yahoo;
    }else if(emailDomain == "WEB") {
      this.pwdInst = web;
    }else if(emailDomain == "ZOHO"){
      this.pwdInst = zoho;
    }else if(emailDomain == "GMX") {
      this.pwdInst = gmx;
    } else if(emailDomain == "ICLOUD" || emailDomain == "ME"){
      this.pwdInst = icloud;
    }else if(emailDomain == "T-ONLINE") {
      this.pwdInst = tonline;
    }
    // eslint-disable-next-line no-empty
  }
}
</script>

<style>

/* Extra small devices (phones, 600px and down) */

@media only screen and (max-width: 600px) {
  .wb-padding-s {
    padding: 0px !important;
    margin-left: 0px !important;
    width: 100% !important;
    margin-top: 30px;
  }
  .imageCls {
    height: auto;
    max-width: 100%;
    padding: 10px;
  }
}
/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {
  .wb-padding-s {
    padding: 0px !important;
    margin-left: 0px !important;
    width: 100% !important;
    margin-top: 30px;
  }
  .imageCls {
    height: auto;
    max-width: 100%;
    padding: 10px;
  }
}
/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
  .wb-padding-s {
    padding: 0px !important;
    margin-left: 0px !important;
    width: 100% !important;
    margin-top: 30px;
  }
  .imageCls {
    height: auto;
    max-width: 100%;
    padding: 10px;
  }
}
/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
  .wb-padding-s {
    padding: 0px !important;
    margin-left: 0px !important;
    width: 100% !important;
    margin-top: 30px;
  }
  .imageCls {
    height: auto;
    max-width: 100%;
    padding: 10px;
  }
}
/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {
  .wb-padding-s {
    padding: 0px !important;
    margin-left: 0px !important;
    width: 100% !important;
    margin-top: 30px;
  }
  .imageCls {
    height: auto;
    max-width: 100%;
    padding: 10px;
  }
}

</style>
